// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payout_item_container {
    width: 100%;
}

table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 16px;
}

tr:nth-child(odd) {
    background-color: var(--bg);
}

tr:nth-child(even) {
    background-color: var(--bg-card);
}

td {
    padding: 14px 12px;
    text-align: left;
    font-size: 13px;
    color: var(--text-primary);
}
`, "",{"version":3,"sources":["webpack://./src/pages/finances/subpages/Payouts/components/payoutItem/payoutItem.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B","sourcesContent":[".payout_item_container {\n    width: 100%;\n}\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 16px;\n}\n\ntr:nth-child(odd) {\n    background-color: var(--bg);\n}\n\ntr:nth-child(even) {\n    background-color: var(--bg-card);\n}\n\ntd {\n    padding: 14px 12px;\n    text-align: left;\n    font-size: 13px;\n    color: var(--text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
